import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const UsersTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/users`,
  rowsPath: 'users',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'forms.edit',
      eventName: 'edit',
      icon: 'EditIcon',
    },
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
    },
  ],
  columns: [
    {
      label: 'fields.id',
      field: 'id',
    },
    {
      label: 'fields.name',
      field: 'name',
    },
    {
      label: 'fields.username',
      field: 'username',
    },
    {
      label: 'fields.slug',
      field: 'slug',
    },
    {
      label: 'fields.phone-number',
      field: 'phone',
    },
    {
      label: 'dashboard.pages-list',
      field: 'pages',
    },
    {
      label: 'auth.login',
      field: 'last_login',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },

  filters: [
    {
      label: 'page.name',
      query: 'page_id',
      colLength: 3,
      type: 'autocomplete',
      multiple: false,
    },
    {
      label: 'fields.id',
      query: 'id',
      colLength: 3,
    },
    {
      label: 'fields.name',
      query: 'name',
      colLength: 3,
    },
    {
      label: 'fields.slug',
      query: 'slug',
      colLength: 3,
    },
    {
      label: 'fields.phone-number',
      query: 'slug',
      colLength: 3,
    },
    {
      label: 'page.active',
      query: 'active',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => [{ name: 'general.yes', id: 1 }, { name: 'general.no', id: 0 }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: true },
    },
    {
      label: 'Has Phone',
      query: 'has_phone',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => [{ name: 'general.yes', id: 1 }, { name: 'general.no', id: 0 }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: true },
    },
    {
      label: 'Has Telegram',
      query: 'has_telegram',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => [{ name: 'general.yes', id: 1 }, { name: 'general.no', id: 0 }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: true },
    },
  ],
}

export default UsersTableConfig
